mutation RestoreNewsletter($id: ID!) {
    campaignRestore(input: {id: $id}) {
        campaign {
            id
        }
    }
}
